import { EditorState, Transaction } from 'prosemirror-state'
import type { Command } from 'common/Prose/Commands'

/**
 * Given an array of commands, combine them all into a single transaction
 * @param state The initial state, before dispatching any commands
 * @param commands The commands to combine
 * @returns A `Transaction` that can be dispatched, or `false` if none of the commands apply to the state that was passed
 */
export const combineCommands = (state: EditorState, commands: Command[]): Transaction | false => {
  let { tr } = state

  const commandResultList: boolean[] = []

  commands.forEach((command) => {
    commandResultList.push(
      command(state, (newTr) => {
        state = state.apply(newTr)
        tr = newTr.steps.reduce((combinedTransaction, step) => {
          return combinedTransaction.step(step)
        }, tr)
      }),
    )
  })

  if (commandResultList.some((result) => result)) {
    return tr
  }
  return false
}
